var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.500000, 3.750000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,4.36725 L14.22375,0.195 C14.00775,0.075 13.764,6.66133815e-16 13.5,6.66133815e-16 L1.5,6.66133815e-16 C1.236,6.66133815e-16 0.9915,0.075 0.77625,0.195 L7.5,4.36725 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89525,5.88675 C7.7745,5.96175 7.63725,6 7.5,6 C7.36275,6 7.2255,5.96175 7.10475,5.8875 L0.00225,1.47975 C0.00225,1.4865 0,1.49325 0,1.49925 L0,8.24925 C0,9.07575 0.67275,9.74925 1.5,9.74925 L13.5,9.74925 C14.32725,9.74925 15,9.07575 15,8.24925 L15,1.49925 C15,1.4925 14.99775,1.48575 14.99775,1.479 L7.89525,5.88675 Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.cfb75bc538ebdc4abac2f8ef835b7c17.svg";
export { ForwardRef as ReactComponent };